module.exports = __webpack_public_path__ + "static/media/how.88f672e2.png";